import {
  GET_USER_SETTINGS_DATA, SAVE_USER_SETTINGS_DATA, SEND_PHONE_VERIFICATION_CODE, VERIFY_USER_PHONE,
  GENERATE_OTP_SECRET_DATA, DELETE_OTP_SECRET_DATA, GET_OTP_SECRET_DATA, VERIFY_USER_OTP, RESET_USER_SETTINGS_DATA,
} from '../../../constants/system/actions';

const getUserSettingsData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_USER_SETTINGS_DATA, payload, resolve, reject,
});

const getOtpSecretData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_OTP_SECRET_DATA, payload, resolve, reject,
});

const saveUserSettingsData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SAVE_USER_SETTINGS_DATA, payload, resolve, reject,
});

const sendPhoneVerificationCode: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SEND_PHONE_VERIFICATION_CODE, payload, resolve, reject,
});

const verifyUserPhone: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: VERIFY_USER_PHONE, payload, resolve, reject,
});

const generateOtpSecretData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GENERATE_OTP_SECRET_DATA, payload, resolve, reject,
});

const verifyUserOtp: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: VERIFY_USER_OTP, payload, resolve, reject,
});

const deleteOtpSecretData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: DELETE_OTP_SECRET_DATA, payload, resolve, reject,
});

const resetUserSettingsData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_USER_SETTINGS_DATA, payload,
});

export {
  getUserSettingsData,
  getOtpSecretData,
  saveUserSettingsData,
  sendPhoneVerificationCode,
  verifyUserPhone,
  generateOtpSecretData,
  verifyUserOtp,
  deleteOtpSecretData,
  resetUserSettingsData,
};
